import React from 'react'

const CoursesFirstTabSubComp = (props) => {
  return (
    <>
        <div className="content" data-aos-delay="400" data-aos="fade-up" data-aos-duration="1800">
            <h2>{props.heading}</h2>
            <p>{props.paragraph}</p>
        </div>
    </>
  )
}

export default CoursesFirstTabSubComp